<div
  class="ai-chat-container"
  [class.splash-mode]="showWelcome && !allConversations"
  [class.chat-active]="!showWelcome && !allConversations"
>
  <div
    *ngIf="!showWelcome || allConversations"
    class="chat-top-bar"
    [class.chat-top-bar-splash]="showWelcome && !allConversations"
    [class.chat-top-bar-list]="allConversations"
  >
    <div
      class="current-title text-capitalize"
      *ngIf="!showWelcome && !allConversations && currentConversationTitle"
      [class.sidebar-expanded]="isSidebarExpanded"
    >
      {{ currentConversationTitle }}
    </div>
    <div class="chat-top-bar-actions">
      <button
        *ngIf="!allConversations"
        type="button"
        class="splash-search-btn"
        (click)="openAllConversationsSearch()"
        title="Search chats"
        aria-label="Search all chats"
      >
        <i class="fal fa-search" aria-hidden="true"></i>
      </button>
      <button type="button" class="new-chat-btn" (click)="startNewConversation()" title="New chat">
        <img src="assets/images/custom/sidebar/chat-new.svg" alt="New chat" width="22" height="22" />
      </button>
    </div>
  </div>

  <div class="splash-top-actions" *ngIf="showWelcome && !allConversations">
    <button
      type="button"
      class="splash-search-btn"
      (click)="openAllConversationsSearch()"
      title="Search chats"
      aria-label="Search all chats"
    >
      <i class="fal fa-search" aria-hidden="true"></i>
    </button>
  </div>

  <div class="splash-glow" *ngIf="showWelcome && !allConversations" aria-hidden="true"></div>

  <div class="conversations-view" *ngIf="allConversations">
    <app-chat-history
      [showAllConversations]="true"
      (conversationSelected)="onConversationSelected($event)"
    ></app-chat-history>
  </div>

  <ng-container *ngIf="!allConversations">
    <!-- Messages -->
    <div
      #chatContainer
      class="chat-scroll"
      *ngIf="!showWelcome"
      (scroll)="onChatScroll()"
    >
      <div class="chat-inner">
        <ng-container *ngFor="let item of chatListItems; trackBy: trackChatItem">
          <div *ngIf="item.type === 'header'" class="day-header" role="separator">
            <span>{{ item.label }}</span>
          </div>

          <article
            *ngIf="item.type === 'message'"
            class="message-row"
            [class.user-row]="item.message.isUser"
            [class.ai-row]="!item.message.isUser"
            [attr.data-message-id]="item.message.id"
          >
            <!-- User message -->
            <div class="user-col" *ngIf="item.message.isUser">
              <div class="user-bubble editing" *ngIf="editingMessageId === item.message.id; else userBubble">
                <textarea
                  [(ngModel)]="editDraft"
                  (keydown)="onEditKeydown($event, item.message)"
                  rows="2"
                  class="edit-textarea"
                  aria-label="Edit message"
                ></textarea>
                <div class="edit-actions">
                  <button type="button" class="edit-cancel" (click)="cancelEdit()">Cancel</button>
                  <button type="button" class="edit-send" (click)="submitEdit(item.message)" [disabled]="!editDraft.trim()">
                    Send
                  </button>
                </div>
              </div>
              <ng-template #userBubble>
                <div
                  class="user-bubble"
                  (contextmenu)="onUserContextMenu($event, item.message)"
                >
                  <p>{{ item.message.content }}</p>
                </div>
              </ng-template>
            </div>

            <!-- Assistant message -->
            <div class="ai-col" *ngIf="!item.message.isUser">
              <app-aya-chat-progress
                *ngIf="shouldShowProgress(item.message)"
                [phases]="getProgressPhases(item.message)"
                [searchSteps]="getSearchSteps(item.message)"
                [statusLine]="getSearchStatus(item.message)"
                [isActive]="isStreamingMessage(item.message)"
              ></app-aya-chat-progress>

              <div
                class="ai-prose"
                *ngIf="getAssistantBody(item.message) as body"
                [innerHTML]="formatAssistantHtml(body, item.message.id!)"
                (click)="onProseClick($event, item.message.id!)"
              ></div>

              <span class="stream-cursor" *ngIf="isStreamingMessage(item.message) && getAssistantBody(item.message)"></span>

              <span class="aya-thinking-fallback" *ngIf="shouldShowAssistantThinking(item.message)">
                <span class="aya-thinking-dot" aria-hidden="true"></span>
                Thinking…
              </span>

              <ng-container *ngIf="getMessageBlocks(item.message) as blocks">
                <app-aya-chat-sources
                  *ngIf="!hideAttribution(item.message) && blocks.sources.length"
                  [sources]="blocks.sources"
                  [messageId]="item.message.id!"
                ></app-aya-chat-sources>

                <app-aya-chat-followups
                  *ngIf="!isStreamingMessage(item.message) && !hideAttribution(item.message) && blocks.followups.length"
                  [items]="blocks.followups"
                  (select)="useQuickQuery($event)"
                ></app-aya-chat-followups>
              </ng-container>

              <div class="ai-actions" *ngIf="getAssistantBody(item.message) && item.message.id">
                <button type="button" class="action-btn" (click)="copyMessage(item.message)" title="Copy">
                  <i class="fal fa-copy"></i>
                </button>
                <button
                  type="button"
                  class="action-btn"
                  [class.active]="isMessageLiked(item.message.id!)"
                  (click)="toggleLike(item.message.id!)"
                  title="Good response"
                >
                  <i [ngClass]="isMessageLiked(item.message.id!) ? 'fas' : 'fal'" class="fa-thumbs-up"></i>
                </button>
                <button
                  type="button"
                  class="action-btn"
                  [class.active]="isMessageDisliked(item.message.id!)"
                  (click)="toggleDislike(item.message.id!)"
                  title="Bad response"
                >
                  <i [ngClass]="isMessageDisliked(item.message.id!) ? 'fas' : 'fal'" class="fa-thumbs-down"></i>
                </button>
                <button
                  type="button"
                  class="action-btn"
                  *ngIf="isLastAssistant(item.message)"
                  (click)="regenerate()"
                  [disabled]="isBusy"
                  title="Regenerate"
                >
                  <i class="fal fa-redo"></i>
                </button>
              </div>
            </div>
          </article>
        </ng-container>

        <app-aya-chat-progress
          *ngIf="shouldShowPendingProgress()"
          [phases]="progressPhases"
          [searchSteps]="searchSteps"
          [statusLine]="streamStatus"
          [isActive]="true"
        ></app-aya-chat-progress>

        <div
          class="typing-indicator"
          *ngIf="isBusy && messages.length && messages[messages.length - 1]?.isUser && !shouldShowPendingProgress()"
        >
          <span></span>
        </div>
      </div>
    </div>

    <!-- Composer -->
    <div
      class="composer-wrap"
      [class.composer-splash]="showWelcome"
      *ngIf="showWelcome || isBusy || (currentConversationId && currentConversationId !== 'all')"
    >
      <div [class.splash-center]="showWelcome">
        <div class="splash-heading" *ngIf="showWelcome">
          <h1 class="splash-title">{{ greetingName }}</h1>
          <p class="splash-subtitle">
            Ask Aya, <em>your</em> AI clinical companion.
          </p>
        </div>

      <button
        type="button"
        class="scroll-bottom-btn"
        *ngIf="showScrollButton && !showWelcome"
        (click)="scrollToBottom(true)"
        aria-label="Scroll to bottom"
      >
        <i class="fal fa-chevron-down"></i>
      </button>

      <div class="attachment-previews" *ngIf="attachmentPreviews.length > 0">
        <div class="attachment-preview" *ngFor="let preview of attachmentPreviews; let i = index">
          <img [src]="preview" alt="Attachment preview" *ngIf="preview.startsWith('data:image')" />
          <div class="preview-placeholder" *ngIf="!preview.startsWith('data:image')">
            <i class="fal fa-file"></i>
          </div>
          <button type="button" class="remove-attachment" (click)="removeAttachment(i)">
            <i class="fal fa-times"></i>
          </button>
        </div>
      </div>

      <div class="composer-card">
        <div class="composer-row">
          <div class="dropdown-container btn-group" dropdown container="body">
            <button class="composer-icon-btn" type="button">
              <i class="fas fa-plus" dropdownToggle aria-expanded="false"></i>
            </button>
            <div class="dropdown-menu" (click)="$event.stopPropagation()" *dropdownMenu>
              <div class="dropdown-item" (click)="fileInput.click()" role="button">
                <i class="fas fa-image me-2"></i>
                <span>Add images or files</span>
              </div>
            </div>
            <input
              #fileInput
              type="file"
              multiple
              accept="image/*,.pdf,.txt"
              (change)="onFileSelected($event)"
              hidden
            />
          </div>

          <textarea
            #chatInput
            class="chat-input"
            [placeholder]="showWelcome ? 'Ask a clinical question — e.g. resistant hypertension in CKD 3' : 'Ask a clinical question'"
            [(ngModel)]="userMessage"
            (keydown.enter)="onEnterKey($event)"
            (input)="adjustTextareaHeight()"
            [disabled]="isBusy"
            rows="1"
          ></textarea>

          <div class="consult-mode-wrap" (click)="$event.stopPropagation()">
            <button
              type="button"
              class="consult-mode-btn"
              (click)="toggleConsultModeMenu($event)"
              [disabled]="isBusy"
              title="Consult depth"
            >
              <i class="fal fa-tachometer-alt"></i>
              <span>{{ consultModeLabel }}</span>
            </button>
            <div class="consult-mode-menu" *ngIf="showConsultModeMenu">
              <button
                type="button"
                *ngFor="let opt of consultModeOptions"
                [class.active]="consultMode === opt.value"
                (click)="setConsultMode(opt.value, $event)"
              >
                {{ opt.label }}
              </button>
            </div>
          </div>

          <button
            class="send-btn stop-btn"
            type="button"
            *ngIf="chatStatus === 'streaming'"
            (click)="stopStreaming()"
            title="Stop"
          >
            <i class="fas fa-stop"></i>
          </button>
          <button
            class="send-btn"
            type="button"
            *ngIf="chatStatus !== 'streaming'"
            (click)="sendMessage()"
            [disabled]="isBusy || !userMessage.trim()"
            title="Send"
          >
            <i class="fas fa-arrow-up"></i>
          </button>
        </div>
      </div>

      <div class="quick-query-chips" *ngIf="showWelcome">
        <button
          type="button"
          class="quick-query-chip"
          *ngFor="let chip of quickQueryChips; let i = index"
          [class.tone-0]="i % 4 === 0"
          [class.tone-1]="i % 4 === 1"
          [class.tone-2]="i % 4 === 2"
          [class.tone-3]="i % 4 === 3"
          (click)="useQuickQuery(chip)"
          [disabled]="isBusy"
        >
          {{ chip }}
        </button>
      </div>
      </div>

      <p class="composer-disclaimer" [class.splash-disclaimer]="showWelcome">
        {{ showWelcome ? splashDisclaimer : chatDisclaimer }}
      </p>

      <div class="warning-banner-bottom" *ngIf="showWarning">
        <div class="warning-content">
          <i class="fas fa-exclamation-triangle"></i>
          <span>{{ warningMessage }}</span>
          <button type="button" class="warning-close" (click)="dismissWarning()">
            <i class="fal fa-times"></i>
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="copy-toast" [class.show]="showCopyToast">
    <i class="fal fa-check"></i>
    <span>Copied!</span>
  </div>

  <div
    class="context-menu"
    *ngIf="showContextMenu"
    [style.left.px]="contextMenuX"
    [style.top.px]="contextMenuY"
    (click)="$event.stopPropagation()"
  >
    <div class="context-menu-item" (click)="copyFromContextMenu()">
      <i class="fal fa-copy"></i><span>Copy</span>
    </div>
    <div class="context-menu-item" *ngIf="contextMenuMessage && canEditMessage(contextMenuMessage)" (click)="beginEditFromMenu()">
      <i class="fal fa-edit"></i><span>Edit</span>
    </div>
  </div>
</div>
